import { from } from "@apollo/client";
import { forceDisableAPQ } from "../utils/storage";
import { headersLink } from "./headers-link";
import { httpLink } from "./http-link";
import { logginglink } from "./logging";
import { persistedQueriesLink } from "./persisted-queries-link";
import { queryVariableOverwritesLink } from "./queryVariableOverwrites";
import { retryLink } from "./retry-link";
export const onegraphLink = ({ customHeaders, customLinks, endpoint, disableAPQ, batman, }) => {
    const links = [
        ...(!disableAPQ && !forceDisableAPQ() ? [persistedQueriesLink()] : []),
        ...(batman ? [queryVariableOverwritesLink(batman)] : []),
        headersLink(customHeaders),
        retryLink(),
        logginglink(),
        httpLink(endpoint),
    ];
    customLinks?.forEach((link) => links.unshift(link));
    return from(links);
};
//# sourceMappingURL=onegraph-link.js.map